const tenants: Record<string, App.Tenant> = {
  lux: {
    title: 'Luxury Escapes',
    value: 'lux',
    brand: 'luxuryescapes',
  },
  scoopon: {
    title: 'Scoopon',
    value: 'scoopon',
    brand: 'scoopontravel',
  },
  cudo: {
    title: 'Cudo',
    value: 'cudo',
    brand: 'cudotravel',
  },
  deals: {
    title: 'Deals',
    value: 'deals',
    brand: 'dealstravel',
  },
  treatme: {
    title: 'Treat Me',
    value: 'treatme',
    brand: 'treatmetravel',
  },
  lebusinesstraveller: {
    title: 'LE Business Traveller',
    value: 'lebusinesstraveller',
    brand: 'lebusinesstraveller',
  },
  leagenthub: {
    title: 'LE Agent Hub',
    value: 'leagenthub',
    brand: 'leagenthub',
  },
  leagenthub_cvfr: {
    title: 'CVFR Holidays',
    value: 'leagenthub_cvfr',
    brand: 'leagenthub_cvfr',
  },
};

export default tenants;
